import { Heading, Text } from 'ui-kit/typography'
import {
  selfHostingFeaturesData,
  SelfHostingFeaturesDataType,
} from './selfHostingFeaturesData'
import classes from './SelfHostingFeatures.module.scss'

export const SelfHostingFeatures = () => {
  return (
    <ul className={classes.list}>
      {selfHostingFeaturesData.map((item, index) => (
        <SelfHostingFeaturesCard key={index} item={item} />
      ))}
    </ul>
  )
}

const SelfHostingFeaturesCard = ({
  item,
}: {
  item: SelfHostingFeaturesDataType
}) => {
  const { Icon, title, description } = item

  return (
    <li className={classes.item}>
      <div className={classes.visual}>
        <div className={classes.box}>
          <Icon className={classes.icon} />
        </div>
      </div>
      <Heading as={'h3'} size={'xs'} center balance className={classes.title}>
        {title}
      </Heading>
      <Text center balance className={classes.description}>
        {description}
      </Text>
    </li>
  )
}
